import { render, staticRenderFns } from "./DocumentPhotoDetail.vue?vue&type=template&id=3e012ba0&scoped=true&"
import script from "./DocumentPhotoDetail.vue?vue&type=script&lang=js&"
export * from "./DocumentPhotoDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e012ba0",
  null
  
)

export default component.exports